import { useQuery } from "@tanstack/react-query";
import { AppConfigsQueryKey } from "@noa/api-client";
import type { AppConfig } from "@noa/ui";
import { fetchAppConfigs } from "~/configs/app-configs";

/** Bootstrap already fetched this file (see main.tsx) and seeded the cache; `staleTime` keeps it. */
export const useAppConfigs = () => {
  const { data, isLoading, isError, isSuccess, ...rest } = useQuery<AppConfig>({
    queryKey: AppConfigsQueryKey.all,
    queryFn: fetchAppConfigs,
    staleTime: Infinity,
  });

  return {
    appConfigs: data,
    isLoadingAppConfigs: isLoading,
    isErrorAppConfigs: isError,
    isAppConfigsReady: isSuccess,
    ...rest,
  };
};
